import { render } from "./AlphaBackgroundButton.vue?vue&type=template&id=4afbeb8a"
import script from "./AlphaBackgroundButton.vue?vue&type=script&lang=js"
export * from "./AlphaBackgroundButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__